import React from 'react';
import PropTypes from 'prop-types';

class JobTasks extends React.Component {
  render() {
    return <div></div>
  }
}

export default JobTasks;



// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job-tasks.js